import React, {useState, useEffect} from 'react';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import Api from '../../../api/SMPFetchHelper';
import {SessionDataGetSchema} from '../../../api/DBSchema/SessionData';
import {useSMCErrorHandler} from '../../../utils/errorUtils';
import ExportSMPStepOne from './ExportSMPStepOne';
import ExportSMPStepTwo from './ExportSMPStepTwo';
import ExportSMPStepThree from './ExportSMPStepThree';

export const ServiceDomainsToExportTypeValues = {
    none: 'None',
    all: 'All',
    specific: 'Specific'
};

function ExportSMPModal({
    isOpen = false,
    onRequestClose
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();

    const [availableDomains, setAvailableDomains] = useState([]);
    const [editorStep, setEditorStep] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');

    const [isExportFirmware, setIsExportFirmware] = useState(false);
    const [isExportAdministrators, setIsExportAdministrators] = useState(true);
    const [isExportSystemSettings, setIsExportSystemSettings] = useState(true);
    
    const [serviceDomainsToExportType, setServiceDomainsToExportType] = useState(ServiceDomainsToExportTypeValues.all);
    const [serviceDomainToExport, setServiceDomainToExport] = useState('');

    const [isExportUsers, setIsExportUsers] = useState(true);
    const [isExportGateways, setIsExportGateways] = useState(true);
    const [isExportPlans, setIsExportPlans] = useState(true);
    const [isExportItems, setIsExportItems] = useState(true);
    const [isExportSettings, setIsExportSettings] = useState(true);


    const pageParams = {
        availableDomains,
        isExportFirmware, setIsExportFirmware,
        isExportAdministrators, setIsExportAdministrators,
        isExportSystemSettings, setIsExportSystemSettings,
        serviceDomainsToExportType, setServiceDomainsToExportType,
        serviceDomainToExport, setServiceDomainToExport,
        isExportUsers, setIsExportUsers,
        isExportGateways, setIsExportGateways,
        isExportPlans, setIsExportPlans,
        isExportItems, setIsExportItems,
        isExportSettings, setIsExportSettings
    };

    // Fetch list of all portals
    useEffect(() => {
        Api.getSessionData({attributes: [
            SessionDataGetSchema.allPortals
        ]})
        .then(resp => {
            const respData = resp.data;
            const allPortals = respData.allPortals;
            setAvailableDomains(allPortals);
            if (allPortals && allPortals.length) {
                setServiceDomainToExport(allPortals[0]);
            }
        })
        .catch(e => {
            const errorMessage = getErrorMessage(e);
            setErrorMessage(errorMessage);
        })
    }, [getErrorMessage]);

    // Reset all values on open
    useEffect(() => {
        if (isOpen) {
            setEditorStep(0);
            setErrorMessage('');
            setServiceDomainsToExportType(ServiceDomainsToExportTypeValues.all);
            
            if (availableDomains && availableDomains.length) {
                setServiceDomainToExport(availableDomains[0]);
            } else {
                setServiceDomainToExport('');
            }
            
            setIsExportFirmware(false);
            setIsExportAdministrators(true);
            setIsExportSystemSettings(true);
            setIsExportUsers(true);
            setIsExportGateways(true);
            setIsExportPlans(true);
            setIsExportItems(true);
            setIsExportSettings(true);        
        }
    }, [isOpen, availableDomains]);

    const onFinish = () => { }

    let EditorBody = () => null;

    switch (editorStep) {
        case 0:
            EditorBody = ExportSMPStepOne;
            break;
        case 1:
            EditorBody = ExportSMPStepTwo;
            break;
        case 2:
            EditorBody = ExportSMPStepThree;
            break;
        default:
            onRequestClose();
            break;
    }

    return (
        <SMCModal
            isOpen={isOpen}
            width={710}
            height={480}
            title={t('SMC_SYSOPS_EXPWIZ_TITLE')}
            onRequestClose={onRequestClose}
            hasError={!!errorMessage}
            errorMessage={errorMessage}
        >
            <EditorBody
                onCancel={onRequestClose}
                onNext={() => setEditorStep(step => step+1)}
                onBack={() => setEditorStep(step => step-1)}
                onFinish={onFinish}
                pageParams={pageParams}
            />
        </SMCModal>

    );
}

export default ExportSMPModal;